import React from 'react';
import {iconName, typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {
  ERROR_MSG_CLASS,
  ERROR_ATTRIBUTE_PREFIX,
  ERROR_STATE,
} from '@packages/systems/users/constants';

import {getErrorAttrName} from './utils';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';

const UserErrorMsg = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const index = data.temp?.index ?? 0;
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const type = data.users?.type;
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const currentMessage = data.errors[index].copy;
    const updatedClasses = classes.push(ERROR_MSG_CLASS);

    const formType = Object.keys(ERROR_STATE).find(
      // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly SIGNUP: "signup-error-state"; readonly LOGIN: "login-error-state"; readonly UPDATE_PASSWORD: "update-password-error-state"; readonly RESET_PASSWORD: "reset-password-error-state"; readonly ACCOUNT_UPDATE: "account-update-error-state"; }'.
      (key) => ERROR_STATE[key] === type
    );

    // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments.
    const errorsAttr = data.errors.reduce<Record<string, any>>(
      // @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7031 - Binding element 'copy' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
      (acc, {copy, id}) => {
        if (formType && id) {
          const errorAttrName = getErrorAttrName(
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly SIGNUP: "wf-signup-form"; readonly LOGIN: "wf-login-form"; readonly RESET_PASSWORD: "wf-reset-pw-form"; readonly UPDATE_PASSWORD: "wf-update-pw-form"; readonly ACCOUNT_UPDATE: "wf-account-update-form"; }'.
            ERROR_ATTRIBUTE_PREFIX[formType],
            id
          );
          acc[errorAttrName] = copy;
        }
        return acc;
      },
      {}
    );

    return (
      <div {...generateAttributes(attributes, updatedClasses)} {...errorsAttr}>
        {currentMessage}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Error Message',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: false,
  hideAncestorSettings: true,
  render: UserErrorMsg,
  constraints: {
    parent: [
      {
        is: ['UserFormErrorState', 'UserFormErrorStateStyleVariant1'],
        name: 'User Form Error',
        rule: 'ExactlyOne',
      },
    ],
  },
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Users'), typeName('UserErrorMsg'))
  ),
});

export default config;
